module.exports = __webpack_public_path__ + "img/icon-exploitations.520af1ca.svg";